<template>
  <div class="avatar cursor-pointer shadow" :class="[radius, size]">
    <template v-if="session.profile_image">
      <img :src="session.profile_image" class="avatar-img" :class="radius" />
    </template>
    <template v-else>
      <img :src="placeholder" class="avatar-img" :class="radius" />
    </template>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { mapState } from "pinia";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    radius: {
      type: String,
      default: "rounded-4",
    },
    size: {
      type: String,
      default: "avatar-xxl",
    },
  },
  computed: {
    ...mapState(useMainStore, ["session"]),
    placeholder() {
      return useMainStore().session?.gender === "female"
        ? require("@/assets/img/avatars/1.png")
        : require("@/assets/img/avatars/2.png");
    },
  },
});
</script>
